module.exports = __webpack_public_path__ + "img/Page3B.0e666c34.jpg";